import { twMerge } from "tailwind-merge";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel?: string;
  className?: string;
  "data-testid"?: string;
}

export const Toggle = ({
  checked,
  onChange,
  ariaLabel,
  className,
  "data-testid": testId,
}: ToggleProps) => {
  return (
    <button
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={() => onChange(!checked)}
      data-testid={testId}
      className={twMerge(
        "relative inline-flex h-4 w-8.5 shrink-0 cursor-pointer items-center rounded-full p-0.25 transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2",
        checked ? "bg-primary-500" : "bg-tertiary-200",
        className
      )}
    >
      <span
        className={twMerge(
          "pointer-events-none h-3.5 w-4.5 transform rounded-full bg-white shadow transition duration-200 ease-in-out",
          checked ? "translate-x-3.5" : "translate-x-0"
        )}
      />
    </button>
  );
};
